import Splide from '@splidejs/splide';

const SELECTORS = {
    block: '.wp-block-ssm-product-featured-image-gallery',
    slider: '.splide',
    thumbnails: '.thumbnails',
    thumbnail: '.thumbnail',
    list: '.splide__list',
    track: '.splide__track',
    arrows: '.splide__arrows',
};

const DEFAULT_OPTIONS = {
    type: 'fade',
    arrows: false,
    pagination: false,
    drag: false,
};

const THUMBS_OPTIONS = {
    type: 'slide',
    perPage: 6,
    gap: '0.5rem',
    arrows: true,
    pagination: false,
    drag: false,
};

export function initProductFeaturedImageGallery(block) {
    const splideEl = block.querySelector(SELECTORS.slider);
    const list = splideEl?.querySelector(SELECTORS.list);
    const track = splideEl?.querySelector(SELECTORS.track);
    const thumbnails = block.querySelectorAll(SELECTORS.thumbnail);
    const thumbsSplideEl = block.querySelector(SELECTORS.thumbnails);

    // Skip if already initialized or missing required elements
    if (!splideEl || !list || !track || splideEl.splide) {
        return null;
    }

    const initThumbnails = (sliderInstance, eventCleanup) => {
        // init thumbnails slider
        const hasArrows = thumbsSplideEl.querySelector(SELECTORS.arrows) !== null;
        const options = {
            ...THUMBS_OPTIONS,
            arrows: hasArrows,
        };

        const thumbsSliderInstance = new Splide(thumbsSplideEl, options);

        // sync so thumbs slider scrolls when main slider moves
        sliderInstance.sync(thumbsSliderInstance);

        thumbsSliderInstance.mount();

        // connect thumbnails to the main slider
        let current;

        const changeThumbClass = (newIndex) => {
            const thumbnail = thumbnails[newIndex ?? sliderInstance.index];

            if (thumbnail) {
                if (current) {
                    current.classList.remove('is-active');
                }

                thumbnail.classList.add('is-active');
                current = thumbnail;
            }
        };

        const initThumbnail = (thumbnail, index) => {
            const handler = () => sliderInstance.go(index);
            thumbnail.addEventListener('click', handler);
            eventCleanup.push(() => thumbnail.removeEventListener('click', handler));
        };

        for (let i = 0; i < thumbnails.length; i++) {
            initThumbnail(thumbnails[i], i);
        }

        sliderInstance.on('mounted', () => changeThumbClass(0));
        sliderInstance.on('moved', changeThumbClass);

        return {
            destroy() {
                if (typeof thumbsSliderInstance.destroy === 'function') {
                    thumbsSliderInstance.destroy(true);
                }
            },
        };
    };

    try {
        let sliderInstance = null;
        let thumbsSliderInstance = null;
        const eventCleanup = [];

        sliderInstance = new Splide(splideEl, DEFAULT_OPTIONS);

        if (thumbsSplideEl) {
            thumbsSliderInstance = initThumbnails(sliderInstance, eventCleanup);
        }

        sliderInstance.mount();

        // Store reference for cleanup
        splideEl.splide = true;

        return {
            destroy() {
                eventCleanup.forEach((cleanup) => cleanup());

                if (thumbsSliderInstance) {
                    thumbsSliderInstance.destroy();
                    thumbsSliderInstance = null;
                }

                if (sliderInstance && typeof sliderInstance.destroy === 'function') {
                    sliderInstance.destroy(true);
                    sliderInstance = null;
                }

                delete splideEl.splide;
            },
        };
    } catch (error) {
        console.error('Error initializing product featured image gallery:', error, splideEl);

        return null;
    }
}

export function ProductFeaturedImageGallery() {
    document.querySelectorAll(SELECTORS.block).forEach((block) => {
        initProductFeaturedImageGallery(block);
    });
}
